import {useReadCodelistQuery} from '@dms/api/core';
import i18n from '@dms/i18n';

import {RentalVehicle} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

export function CarParkIdSelect() {
  const {
    data: carParkData,
    isLoading: isLoadingCarParkData,
    isError: isCarParkDataError,
  } = useReadCodelistQuery({codelistId: 'carPark'});

  const carParkOptions =
    carParkData?.codes
      ?.filter((item) => item.isDisabled === false)
      .map((code) => ({value: code.codeId, label: code.name})) || [];

  return (
    <Field<RentalVehicle, 'choice'>
      type="choice"
      name="rentalProperties.carParkId"
      label={i18n.t('entity.rental.labels.carParkId')}
      isRequired
      isLoading={isLoadingCarParkData}
      options={carParkOptions}
      isDisabled={isCarParkDataError}
    />
  );
}
